module.exports = __webpack_public_path__ + "img/icon_4_10.40811985.png";